import { render } from "./ListWrapper.vue?vue&type=template&id=2be582d0&scoped=true"
import script from "./ListWrapper.vue?vue&type=script&lang=js"
export * from "./ListWrapper.vue?vue&type=script&lang=js"

import "./ListWrapper.vue?vue&type=style&index=0&id=2be582d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be582d0"]])

export default __exports__